<script lang="ts" setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { type ArticleCardResponse, getBuilderArticles } from '@/api';
import SectionHeader from '@/components/SectionHeader.vue';
import ArticleList from '@/components/articles/ArticleList.vue';
import { useSsgState } from '@/utilities/ssg-state.ts';
import { Constants } from '@/utilities/constants.ts';

const { builderId, builderName } = defineProps<{
  builderId: number;
  builderName: string;
}>();

const { t } = useI18n();

const articles = ref<ArticleCardResponse[] | null>(null);

const loadArticles = async () => {
  const result = await getBuilderArticles({ path: { builderId } });
  if (!result.data) {
    throw new Error(`Failed to fetch builder articles. ${JSON.stringify(result.error)}`);
  }
  articles.value = result.data.items;
};

// Un article publié ou retiré dans la journée doit apparaître sans attendre le pré-rendu de nuit.
useSsgState({
  key: `builder-articles:${builderId}`,
  refs: { articles },
  isLoaded: () => articles.value !== null,
  load: loadArticles,
  refreshOnClient: true,
});

watch(
  () => builderId,
  () => {
    void loadArticles();
  }
);
</script>

<template>
  <section v-if="articles && articles.length > 0" :id="Constants.ScrollAnchors.BuilderArticles" class="scroll-mt-20">
    <SectionHeader>{{ t('views.builder.articles', { name: builderName }) }}</SectionHeader>
    <ArticleList :articles="articles" :lead="true" />
  </section>
</template>
